<template>
    <div style="width: 100%">
        <textarea class="form-control m-input" :id="id"></textarea>
    </div>
</template>

<script>
export default {
  name: 'CKEditor',
  props: ['value', 'id'],
  data () {
    return {
      editor: null,
      addedData: false
    }
  },
  mounted: function () {
    var vm = this
    this.editor = window.CKEDITOR.replace(this.id)
    this.editor.setData(this.value)

    this.editor.on('change', function (evt) {
      vm.$emit('input', evt.editor.getData())
      // vm.$emit('change', evt.editor.getData())
    })
  },
  watch: {
    value: function (value) {
      // update value
      if (!this.addedData) {
        this.editor.setData(value)
        this.addedData = true
      }
    }
  },
  destroyed: function () {
    window.CKEDITOR.instances[this.id].destroy()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/core/CKEditor.vue